import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import WaterSourceForm from '../Forms/WaterSourceForm';

const AddEditWaterSourceModal = ({
	dataWaterSource,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Fuente de Agua
			</ModalHeader>

			<WaterSourceForm
				dataWaterSource={dataWaterSource}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditWaterSourceModal;
